module.exports = __webpack_public_path__ + "img/1F607.3dc435ab.svg";